import * as _ from "lodash";
import * as React from "react";
import { useEffect } from "react";
import * as Models from "../../../Models";
import { DataGridReusable } from "./TableReusable";

type IDataGridProps = {
    content: Models.DataGridContent;
    showPagination: boolean;
    isSortable: boolean;
    filterable: boolean;
    defaultPageSize?: number;
    columnEditable?: boolean;
    filterableColumns?: string[];
    exportColumns?: Models.ExportColumn[];
    searchIndex: string;
    latestAction: string;
    removedColumns: string[];

    // onReactTableColumnReOrder?: (columns: any) => void;
    // onReactTableSort?: (sort: any) => void;
    // onReactTableFilter?: (filters: any) => void;
    // onSetRemovedColumns?: (columns: string[]) => void;
};

export default function SearchDataGrid(props: IDataGridProps) {
    const {
        content,
        filterableColumns = [],
        removedColumns: initialRemovedColumns,
        exportColumns = [],
        latestAction,
        // onReactTableColumnReOrder,
    } = props;

    const initializeColumns = (): Models.SearchResultColumn[] => {
        return content.columns.map((c: any, i) =>
            _.assign({}, c, {
                order: c.order !== undefined ? c.order : i,
                filterable: filterableColumns.indexOf(c.Header) > -1,
            })
        );
    };

    const [columns, setColumns] = React.useState<Models.SearchResultColumn[]>(
        initializeColumns()
    );
    const [removedColumns, setRemovedColumns] = React.useState<string[]>(
        initialRemovedColumns
    );
    const [exported, setExported] = React.useState<boolean>(false);

    useEffect(() => {
        if (latestAction === "export") {
            let columnList = exportColumns.map((f) => f.displayName);
            columnList = columnList.filter(
                (c) => removedColumns.indexOf(c) < 0
            );

            const filteredCols = _.filter(
                columns,
                (f: any) => columnList.indexOf(f.Header) >= 0
            );

            const newCols = filteredCols.map((c) => {
                const existing = _.find(
                    exportColumns,
                    (col) => col.displayName === c.Header
                );
                const order = existing ? existing.order : c.order;
                return _.assign({}, c, { order });
            });

            const sortedCols = _.sortBy(newCols, "order");
            setColumns(sortedCols);
            setExported(true);
        }

        // onReactTableColumnReOrder?.(columns);
    }, []);

    // Update columns if props/content change
    useEffect(() => {
        const totalColumnCount = props.content.columns.length;
        const stateColCount = columns.length;
        const removedColCount = removedColumns.length;

        if (
            props.content.columns.length !== totalColumnCount ||
            !_.isEqual(columns, props.content.columns) ||
            !_.isEqual(removedColumns, props.removedColumns)
        ) {
            if (
                totalColumnCount !== stateColCount + removedColCount &&
                !exported
            ) {
                updateColumnsFromProps(props);
            }
        }
    }, [props.content.columns, props.removedColumns]);

    const updateColumnsFromProps = (props: IDataGridProps): void => {
        let updatedRemovedColumns = [...removedColumns];

        updatedRemovedColumns = updatedRemovedColumns.filter((c) => {
            const colname = c.substring(c.indexOf(" ") + 1);
            return props.content.columns.some(
                (f) => f.Header === colname || f.Header === c
            );
        });

        const newCols = props.content.columns
            .filter((c) => updatedRemovedColumns.indexOf(c.Header) < 0)
            .map((c, i) => {
                const existing = _.find(
                    columns,
                    (col: any) => col.accessor === c.accessor
                );
                const order = existing
                    ? existing.order
                    : props.content.columns.length - 1;
                return _.assign({}, c, {
                    order,
                    filterable: filterableColumns.indexOf(c.Header) > -1,
                });
            });

        setColumns(_.sortBy(newCols, "order"));
        setRemovedColumns(updatedRemovedColumns);
    };

    // Final columns for display (excluding removed ones)
    const visibleColumns = columns.filter(
        (c) => removedColumns.indexOf(c.Header) < 0
    );

    const renderedColumns = _.map(visibleColumns, (col: any) =>
        _.assign({}, col, {
            minWidth: 150,
        })
    );

    return (
        <DataGridReusable
            defaultPageSize={props.defaultPageSize ?? 150000}
            data={content.data}
            columns={renderedColumns}
            showPagination={props.showPagination}
            filterable={props.filterable}
            isSortable={props.isSortable}
            columnsReorderingEnabled={props.columnEditable}
            fromSearchDataGrid={true}
        />
    );
}
